/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3DataCentersDcIdFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3DataCentersDcIdFormat = ClosedEnum<
  typeof GetApiV3DataCentersDcIdFormat
>;

export const GetApiV3DataCentersDcIdIncludeNodeType = {
  ApiBoundary: "API_BOUNDARY",
  Replica: "REPLICA",
} as const;
export type GetApiV3DataCentersDcIdIncludeNodeType = ClosedEnum<
  typeof GetApiV3DataCentersDcIdIncludeNodeType
>;

export type GetApiV3DataCentersDcIdRequest = {
  dcId: string;
  /**
   * Subnet ID
   */
  subnet?: string | null | undefined;
  format?: GetApiV3DataCentersDcIdFormat | undefined;
  /**
   * Node Types
   */
  includeNodeType?: Array<GetApiV3DataCentersDcIdIncludeNodeType> | undefined;
};

/** @internal */
export const GetApiV3DataCentersDcIdFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3DataCentersDcIdFormat
> = z.nativeEnum(GetApiV3DataCentersDcIdFormat);

/** @internal */
export const GetApiV3DataCentersDcIdFormat$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3DataCentersDcIdFormat
> = GetApiV3DataCentersDcIdFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3DataCentersDcIdFormat$ {
  /** @deprecated use `GetApiV3DataCentersDcIdFormat$inboundSchema` instead. */
  export const inboundSchema = GetApiV3DataCentersDcIdFormat$inboundSchema;
  /** @deprecated use `GetApiV3DataCentersDcIdFormat$outboundSchema` instead. */
  export const outboundSchema = GetApiV3DataCentersDcIdFormat$outboundSchema;
}

/** @internal */
export const GetApiV3DataCentersDcIdIncludeNodeType$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3DataCentersDcIdIncludeNodeType> = z.nativeEnum(
    GetApiV3DataCentersDcIdIncludeNodeType,
  );

/** @internal */
export const GetApiV3DataCentersDcIdIncludeNodeType$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3DataCentersDcIdIncludeNodeType> =
    GetApiV3DataCentersDcIdIncludeNodeType$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3DataCentersDcIdIncludeNodeType$ {
  /** @deprecated use `GetApiV3DataCentersDcIdIncludeNodeType$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3DataCentersDcIdIncludeNodeType$inboundSchema;
  /** @deprecated use `GetApiV3DataCentersDcIdIncludeNodeType$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3DataCentersDcIdIncludeNodeType$outboundSchema;
}

/** @internal */
export const GetApiV3DataCentersDcIdRequest$inboundSchema: z.ZodType<
  GetApiV3DataCentersDcIdRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  dc_id: z.string(),
  subnet: z.nullable(z.string()).default(null),
  format: GetApiV3DataCentersDcIdFormat$inboundSchema.default("json"),
  include_node_type: z.array(
    GetApiV3DataCentersDcIdIncludeNodeType$inboundSchema,
  ).optional(),
}).transform((v) => {
  return remap$(v, {
    "dc_id": "dcId",
    "include_node_type": "includeNodeType",
  });
});

/** @internal */
export type GetApiV3DataCentersDcIdRequest$Outbound = {
  dc_id: string;
  subnet: string | null;
  format: string;
  include_node_type?: Array<string> | undefined;
};

/** @internal */
export const GetApiV3DataCentersDcIdRequest$outboundSchema: z.ZodType<
  GetApiV3DataCentersDcIdRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3DataCentersDcIdRequest
> = z.object({
  dcId: z.string(),
  subnet: z.nullable(z.string()).default(null),
  format: GetApiV3DataCentersDcIdFormat$outboundSchema.default("json"),
  includeNodeType: z.array(
    GetApiV3DataCentersDcIdIncludeNodeType$outboundSchema,
  ).optional(),
}).transform((v) => {
  return remap$(v, {
    dcId: "dc_id",
    includeNodeType: "include_node_type",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3DataCentersDcIdRequest$ {
  /** @deprecated use `GetApiV3DataCentersDcIdRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3DataCentersDcIdRequest$inboundSchema;
  /** @deprecated use `GetApiV3DataCentersDcIdRequest$outboundSchema` instead. */
  export const outboundSchema = GetApiV3DataCentersDcIdRequest$outboundSchema;
  /** @deprecated use `GetApiV3DataCentersDcIdRequest$Outbound` instead. */
  export type Outbound = GetApiV3DataCentersDcIdRequest$Outbound;
}

export function getApiV3DataCentersDcIdRequestToJSON(
  getApiV3DataCentersDcIdRequest: GetApiV3DataCentersDcIdRequest,
): string {
  return JSON.stringify(
    GetApiV3DataCentersDcIdRequest$outboundSchema.parse(
      getApiV3DataCentersDcIdRequest,
    ),
  );
}

export function getApiV3DataCentersDcIdRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3DataCentersDcIdRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3DataCentersDcIdRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3DataCentersDcIdRequest' from JSON`,
  );
}
